import React from 'react';
import ModularAppView from './ModularAppView';

export default function RecoveryCodesApp() {
  return (
    <ModularAppView
      slug="recovery-codes"
      defaultTitle="Recovery Codes"
      defaultIcon="ShieldAlert"
      defaultCategory="Security"
    />
  );
}
